import { atom } from 'jotai'

type Input = {
  isShow: boolean
}

const state = atom<Input>({
  isShow: false,
})
export const judgeApprovalRequestStore = { state } as const
